// extracted by mini-css-extract-plugin
export default {"CreateChatMessage":"CreateChatMessage-module-afc659fa92efac12dfe7"};